export const FETCH_ALL = 'FETCH_ALL';
export const CREATE = 'CREATE';